import { TranslateService } from '@ngx-translate/core';

import { CampaignStateEnum } from '../../shared/enums/campaign-state-enum';
import { CampaignStateTypeEnum } from '../../shared/enums/campaign-state-type-enum';

export function translateCampaignStateType(campaignStateType: string, translateService: TranslateService): any {
  if (campaignStateType === CampaignStateTypeEnum.EXTERNAL) {
    return translateService.instant(CampaignStateTypeEnum.EXTERNAL);
  } else if (campaignStateType === CampaignStateTypeEnum.INTERNAL) {
    return translateService.instant(CampaignStateTypeEnum.INTERNAL);
  } else {
    return '';
  }
}

export function getCampaignStateAndTranslateDescription(
  campaignStateId: number,
  translateService: TranslateService,
): string {
  let campaignStateAndTranslatedDescription = '';

  switch (campaignStateId) {
    case CampaignStateEnum.NEW_CAMPAIGN: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.NEW_CAMPAIGN],
      );
      campaignStateId = 0;
      break;
    }
    case CampaignStateEnum.PREPARE_DATA: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.PREPARE_DATA],
      );
      break;
    }
    case CampaignStateEnum.PUBLISH_DATE: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.PUBLISH_DATE],
      );
      break;
    }
    case CampaignStateEnum.COMPLAINT_DATE_OF_DISPATCH: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.COMPLAINT_DATE_OF_DISPATCH],
      );
      break;
    }
    case CampaignStateEnum.RECOURSE_CLAIM_DATE_OF_DISPATCH: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.RECOURSE_CLAIM_DATE_OF_DISPATCH],
      );
      break;
    }
    case CampaignStateEnum.NEGOTIATED: {
      campaignStateAndTranslatedDescription = translateService.instant(CampaignStateEnum[CampaignStateEnum.NEGOTIATED]);
      break;
    }
    case CampaignStateEnum.DUE_DATE_REVENUES: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.DUE_DATE_REVENUES],
      );
      break;
    }
    case CampaignStateEnum.COMPLETELY_BOOKED: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.COMPLETELY_BOOKED],
      );
      break;
    }
    case CampaignStateEnum.CANCELLED_STOPPED_CHANGED: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.CANCELLED_STOPPED_CHANGED],
      );
      break;
    }
    case CampaignStateEnum.NO_SUPPLIER_FAULT: {
      campaignStateAndTranslatedDescription = translateService.instant(
        CampaignStateEnum[CampaignStateEnum.NO_SUPPLIER_FAULT],
      );
      break;
    }
    default: {
      break;
    }
  }
  return `${campaignStateId} - ${campaignStateAndTranslatedDescription}`;
}
